export default {
  StateBudget: 0,
  ForeignDebt: 1,
  FeeLeave: 2,
  WelfareFund: 3,
  CareerActivitie: 4,
  BusinessCapital: 5,
  OtherSource: 6,
};
